import { Component, OnInit, Inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";

declare var google; 
@Component({
  selector: 'app-add-location-question',
  templateUrl: './add-location-question.component.html',
  styleUrls: ['./add-location-question.component.css']
})
export class AddLocationQuestionComponent implements OnInit {
  @ViewChild('mapQuestionInDialog') gmapElement: any;

  googleMap;
  mapLat;
  mapLng;
  markerOnMap:any;
  locationNotSerachedYet = true;
  err:String;
  showLoaderForAutoDetectingLocation = true;
  addressInSearchBar = '';
  dataWasPresent = false;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef :MatDialogRef<AddLocationQuestionComponent>, private cdr:ChangeDetectorRef) { 
    if(!(this.data.lat && this.data.lng)){
      this.data = {"lat": 28.635955199999998, "lng": 77.25056};
      this.getLocationData();
    }
    else{
      this.dataWasPresent = true;
      this.showLoaderForAutoDetectingLocation = false;
      this.codeLatLng(this.data.lat, this.data.lng);
    }
    this.mapLat = this.data.lat;
    this.mapLng = this.data.lng;
  }

  ngOnInit() {
  }

  ngAfterViewInit(){
    this.addMap();
  }


  codeLatLng(lat, lng) {
    this.mapLat = lat;
    this.mapLng = lng;
    let geocoder = new google.maps.Geocoder();
    var latlng = new google.maps.LatLng(lat, lng);
    geocoder.geocode({
      'latLng': latlng
    },  (results, status)=> {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[1]) {
          this.addressInSearchBar = results[1]['formatted_address'];
          this.cdr.detectChanges();
        } else {
          console.log('No results found');
        }
      } else {
        console.log('Geocoder failed due to: ' + status);
      }
    });
  }

  addMap() {
    var latLngVar = { lat: this.mapLat, lng: this.mapLng };
    var map = new google.maps.Map(
      this.gmapElement.nativeElement, { zoom: 9, center: latLngVar, mapTypeId: google.maps.MapTypeId.ROADMAP,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true });
    this.googleMap = map;

    this.googleMap.addListener('click', (e) => {
      if(!this.markerOnMap.getVisible()){
        this.markerOnMap.setPosition(e.latLng);
        this.markerOnMap.setVisible(true);
      }
    });

    var input = document.getElementById('address');
    var autocomplete = new google.maps.places.Autocomplete(input, { });

    // Bind the map's bounds (viewport) property to the autocomplete object,
    // so that the autocomplete requests use the current map bounds for the
    // bounds option in the request.
    autocomplete.bindTo('bounds', map);

    // Set the data fields to return when the user selects a place.
    autocomplete.setFields(
      ['address_components', 'geometry', 'icon', 'name']);

    var infowindow = new google.maps.InfoWindow();
    var infowindowContent = document.getElementById('infowindow-content');
    infowindow.setContent(infowindowContent);
    this.markerOnMap = new google.maps.Marker({
      map: map,
      anchorPoint: new google.maps.Point(0, -29),
      draggable: true
    });
    this.markerOnMap.setVisible(false);

    if(this.dataWasPresent){
      let position = new google.maps.LatLng(this.data.lat, this.data.lng);
      this.googleMap.setCenter(position);
      this.markerOnMap.setPosition(position);
      this.markerOnMap.setVisible(true);
    }
    
    this.markerOnMap.addListener('dragend', (event) => {
      this.codeLatLng(event.latLng.lat(), event.latLng.lng());
    });

    autocomplete.addListener('place_changed', () => {
      this.locationNotSerachedYet = false;
      this.markerOnMap.setVisible(false);
      var place = autocomplete.getPlace();
      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        window.alert("No details available for input: '" + place.name + "'");
        return;
      }
      this.mapLat = place.geometry.location.lat();
      this.mapLng = place.geometry.location.lng();
      // If the place has a geometry, then present it on a map.
      if (place.geometry.viewport) {
        map.fitBounds(place.geometry.viewport);
      } else {
        map.setCenter(place.geometry.location);
        map.setZoom(17);  // Why 17? Because it looks good.
      }
      this.markerOnMap.setPosition(place.geometry.location);
      this.markerOnMap.setVisible(true);

      var address = '';
      if (place.address_components) {
        address = [
          (place.address_components[0] && place.address_components[0].short_name || ''),
          (place.address_components[1] && place.address_components[1].short_name || ''),
          (place.address_components[2] && place.address_components[2].short_name || '')
        ].join(' ');
      }
    });

  }

  done(){
    this.dialogRef.close({
      latitude: this.mapLat,
      longitude: this.mapLng
    })
  }

  close(){
    this.dialogRef.close();
  }

  getLocationData() {
    navigator.geolocation.getCurrentPosition((location) => {
      this.showLoaderForAutoDetectingLocation = false;
      let mapLocationValue = {};
      mapLocationValue['latitude'] = (location.coords.latitude);
      mapLocationValue['longitude'] = (location.coords.longitude);
      if(this.locationNotSerachedYet && this.googleMap){
        let position = new google.maps.LatLng(mapLocationValue['latitude'], mapLocationValue['longitude']);
        this.googleMap.setCenter(position);
        this.markerOnMap.setPosition(position);
        this.markerOnMap.setVisible(true);
        this.codeLatLng(mapLocationValue['latitude'], mapLocationValue['longitude']);
      }
    },
    error => {
      this.showLoaderForAutoDetectingLocation = false;
          switch(error.code) {
            case error.PERMISSION_DENIED:
              this.err = 'Seems like you have blocked the location. Please unblock it from browser\'s settings.';
              break;
            case error.POSITION_UNAVAILABLE:
              this.err = 'Location information is unavailable.';
              break;
            case error.TIMEOUT:
              this.err = 'Location detection timed out.';
              break;
            case 2:
              this.err = 'An unknown error occurred.';
              break;
          }
      },
      { timeout: 9000, enableHighAccuracy: true})
}
  
}



// WEBPACK FOOTER //
// ./src/app/add-location-question/add-location-question.component.ts